import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import interviewApi from "./api/interview.api";
import profileApi from "./api/profile.api";
import authApi from "./api/auth.api";
import interviewListReducer from "./slices/interviewListSlice";
export const store = configureStore({
  reducer: {
    interviewList: interviewListReducer,
    auth: authReducer,
    [interviewApi.reducerPath]: interviewApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(interviewApi.middleware)
      .concat(profileApi.middleware)
      .concat(authApi.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
